import ZTime from "./ZTime";

class ZCache {

  static Cache = {};
  static Expire = {};

  static ClearCache(){
    this.Cache = {};
    this.Expire = {};
    this.lastClear = ZTime.Now();
  }

  // 1 day auto Clean
  static AutoClean(){
    if(ZTime.NowIsAfter(this.lastClear.add(1, "days"))){
      console.log(this.CLog("Auto Clean."));
      this.ClearCache();
    }
  }

  static Delete(cache){
    if(!this.Exists(cache)) return false;
    delete this.Cache[cache];
    if(this.Expire[cache]){
      delete this.Expire[cache];
    }
  }

  static Exists(cache){
    return this.Cache[cache] !== undefined;
  }

  static setExpire(cache, duration, unit){
    this.Expire = this.Expire ?? {};
    this.Expire[cache] = ZTime.Now().add(duration, unit);
  }

  static isExpired(cache){
    if(!this.Expire[cache]) return true;
    return ZTime.NowIsAfter(this.Expire[cache]);
  }

  static Set(cache, value, duration = 15, unit = "minutes"){
    this.Cache[cache] = value;
    this.setExpire(cache, duration, unit);
  }

  /**
   * 
   * @param {String} cache key to the store 
   * @param {Function} fallback 
   * @param {Number} duration default: 15
   * @param {moment.unitOfTime.DurationConstructor} unit default: "minutes"
   * @returns 
   */
  static Get(cache, fallback, duration = 15, unit = "minutes"){
    if(this.Exists(cache) && !this.isExpired(cache)){
      return this.Cache[cache];
    }
    let value = fallback?.();
    this.Set(cache, value, duration, unit);
    return value;
  }

  /**
   * 
   * @param {String} cache key to the store
   * @param {Promise<Function>} fallback 
   * @param {Number} duration default: 15
   * @param {moment.unitOfTime.DurationConstructor} unit default: "minutes"
   * @returns 
   */
  static async GetAsync(cache, fallback, duration = 15, unit = "minutes"){
    if(this.Exists(cache) && !this.isExpired(cache)){
      return this.Cache[cache];
    }
    let value = await fallback?.();
    this.Set(cache, value, duration, unit);
    return value;
  }

}

export default ZCache;